export default __webpack_public_path__ + "static/media/amrit.bad34c07.JPG";